import React from 'react'

export default function CustomersAccountsListHeaderStyle({signed_in}) {
  let tb_buttons_display = null
  if (signed_in !== 'admin')
    tb_buttons_display = { customers_accounts_fc: (signed_in.user_access.customers_accounts_fc) ? 'block' : 'none', }
  else tb_buttons_display = { customers_accounts_fc: 'block' }

  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /*
        #refresh-list:hover .tooltip-text { left: 0%; }
        #refresh-list:hover .tooltip-text::after { left: 30%; }
        #settings:hover .tooltip-text { left: 21%; }
        #add-new-credit-account:hover .tooltip-text { left: 16.8%; }
        #add-new-credit-account:hover .tooltip-text:after { left: 56%; }
        #batch-delete:hover .tooltip-text { left: 50%; }
        #batch-delete:hover .tooltip-text:after { left: 75%; }
        */

        /** Toolbar Button's **/
        /* if user is not allowed to add then the user is not allowed to delete as well */
        #add-new-customer, #batch-delete { display: ${tb_buttons_display.customers_accounts_fc}; }

        #customer-accounts-list-toolbar {
          display: flex;
          padding: 5px 0;
        }
      `}
      </style>
    </React.Fragment>
  )
}
